
<div class="container-fluid">
<div class="container middle_content">
  <div class="row  py-4">
    <div class="col-md-5 col-sm-6 col-xl-3 order_bottom">
      <!-- Content for the first column goes here -->
      <div class="card transparent-card">
        <button class="btn btn-primary mb-2" routerLink="/online-services/login" >
          <i class="fas fa-rupee-sign" ></i>Donate Now </button>
        <!-- Button 2 -->
        <button class="btn btn-primary" routerLink="/online-services/login" >
          <i class="fas fa-calendar-alt"></i> Book Rooms </button>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xl-5 p-0 order_top">
      <!-- Content for the second column goes here -->
      <div class="card transparent-card online_services">
        <div class="latest_news  ms-4 me-4">
          <h3>Online Services</h3>
          <!-- <div class="marquee-container">
            <span class="marquee-text">Quota for the month of November released on 6th September 2023. </span>
         
          </div> -->

         
          <div class="marquee-container">
            <span class="marquee-text1"  *ngFor="let item of arr_onlineservices" (click)="bindnotificationdetail(item)" style="cursor: pointer;">{{item.Title}}<img src="/assets/website-assets/images/blnk.gif" class=" blink" style="top: -2px;"> </span>
          </div>

          <!-- marquee-container.component.html -->

        </div><div class="card transparent-card ps-4 pe-4 pt-2">
        <p>निर्गुणं वाम भागे च सव्य भागे अदभुतानिजा । मध्य भागे स्वयं पूर्ण: तस्मै नाथाय ते नमः ।।</p>
        <a routerLink="/home-page/history&mythology" class="read_more">Read More</a>
      </div></div>
    </div>
    <div class="col-md-5  col-sm-6 col-xl-3 order_bottom">
      <!-- Content for the third column goes here -->
      <div class="card transparent-card">
        <button class="btn btn-primary mb-2" routerLink="/online-services/login">
          <i class="fas fa-om"></i> Book Poojan Packages </button>
        <!-- Button 2 -->
        <button class="btn btn-primary mb-2" routerLink="/online-services/login">
          <i class="fas fa-car"></i> Book Vehicle Pass &nbsp;</button>
        <!-- <a routerLink="/online-services/login" class="btn btn-primary">
          <i class="fas fa-car"></i> Book Vehicle Pass </a> -->
      </div>
    </div>
 <div class="col-md-1">
  <img src="assets/website-assets/images/trishul.png" class="img-fluid trishul">
  </div>
</div>
</div>
</div>




<section class="container-fluid">
	
	<div class="container p-0 ">
	 <div class="latest_news current_updates">
	 
                <h3>Current  Updates</h3>
                <!-- <div class="marquee-container">
                  <span class="marquee-text">Quota for the month of November released on 6th September 2023. </span>
                </div> -->
                <div class="marquee-container">
                  <span class="marquee-text" *ngFor="let item of arr_currentupdates" (click)="bindnotificationdetail(item)" style="cursor: pointer;" >{{item.Title}}<img src="/assets/website-assets/images/blnk.gif" class=" blink" style="top:-6px" ></span>
                </div>
              </div>  </div> 
			  </section>




<footer class="container-fluid">
  <div class="container site_footer">
    <div class="row">
      <div class="text-start d-flex align-items-center col-xl-4 col-sm-4  copy_right col-md-12 col-xs-12">
        <p>Copyrights © {{ CurrentYear}}. All Rights Reserved </p>
      </div>
      <nav class="text-center d-flex align-items-center col-xl-6 col-md-8  col-sm-5 col-xs-12">
        <ul>
          <li>
            <a routerLink="/home-page/terms-conditions">Terms and Conditions </a>
          </li>
          <li>
            <a  routerLink="/home-page/privacy-policy">Privacy Policy</a>
          </li>
          <li>
            <a routerLink="/home-page/cancellation&refund">Cancellation & Refund Policy</a>
          </li>
        </ul>
      </nav>
      <div class="text-end  col-md-4 col-sm-3  col-xl-2 col-xs-12 text-lg-end">
        <a href="https://www.cybrain.co.in/" target="_blank" title="Cybrain Software Solutions">
          <img src="/assets/website-assets/images/cybrain_logo.png" alt="bbnt">
        </a>
      </div>
    </div>
  </div>

</footer>


<section class="effect">
	<div class="set"> 
<div>
<img src="/assets/website-assets/images/leaves1.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves2.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves3.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves4.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves5.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves6.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves7.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves8.png" > </div>


</div>


	<div class="set set2"> 
<div>
<img src="/assets/website-assets/images/leaves1.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves2.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves3.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves4.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves5.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves6.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves7.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves8.png" > </div>

</div>	

<div class="set set3"> 
<div>
<img src="/assets/website-assets/images/leaves1.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves2.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves3.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves4.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves5.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves6.png" > </div>

<div>
<img src="/assets/website-assets/images/leaves7.png" > </div>
<div>
<img src="/assets/website-assets/images/leaves8.png" > </div>

</div>

</section>

